import { Component, ReactNode } from 'react';
import { AdminApi } from '../admin-api';

export default class Header extends Component {
  constructor(
    readonly props: Readonly<{
      children?: ReactNode;
      navigate?: any;
      currentUser: any;
    }>,
  ) {
    super(props);
  }

  async logout(e: Event) {
    e.preventDefault();
    const _r = await AdminApi.post('/logout', {});

    if (_r) {
      this.props.navigate('/login', { replace: true });
    }

    return false;
  }

  render(): ReactNode {
    return (
      <header className="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0 shadow main-color">
        <a
          className="navbar-brand col-md-3 col-lg-2 me-0 px-3"
          href="#"
          style={{ paddingBottom: '0', paddingTop: '0' }}
        >
          <img
            src="/assets/img/plurie-no-icon.png"
            style={{ width: '100px' }}
            alt="img"
          />
        </a>
        <button
          className="navbar-toggler position-absolute d-md-none collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#sidebarMenu"
          aria-controls="sidebarMenu"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="navbar-nav">
          <div className="nav-item text-nowrap">
            <a
              className="nav-link px-3 white-text"
              href="#"
              onClick={(e: any) => this.logout(e)}
            >
              Sair
            </a>
          </div>
        </div>
      </header>
    );
  }
}
